/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IUploadModalSlice {
  isShowUploadModal: boolean;
  isRefetchMusic: boolean;
  isRefetchAudoji: boolean;
}

const initialState: IUploadModalSlice = {
  isShowUploadModal: false,
  isRefetchMusic: false,
  isRefetchAudoji: false,
};

export const uploadModalSlice = createSlice({
  name: "uploadModal",
  initialState,
  reducers: {
    setIsShowUploadModal: (
      state: IUploadModalSlice,
      action: PayloadAction<boolean>,
    ) => {
      const { payload } = action;
      state.isShowUploadModal = payload;
    },
    setIsRefetchMusic: (
      state: IUploadModalSlice,
      action: PayloadAction<boolean>,
    ) => {
      const { payload } = action;
      state.isRefetchMusic = payload;
    },
    setIsRefetchAudoji: (
      state: IUploadModalSlice,
      action: PayloadAction<boolean>,
    ) => {
      const { payload } = action;
      state.isRefetchAudoji = payload;
    },
  },
});

const { actions, reducer } = uploadModalSlice;

export const { setIsShowUploadModal, setIsRefetchMusic, setIsRefetchAudoji } =
  actions;

export default reducer;
